import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { XMEI_PRIMARY_COLOR, XMEI_SECONDARY_COLOR } from '../consts/common';

const useStyles = (theme) => ({
  root: {
    margin: 8,
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
});

export const ConfirmButton = withStyles(useStyles)(Button);
